// extracted by mini-css-extract-plugin
module.exports =  {"secondaryNavbar":"secondaryNavbar_nqYzsGhL","marginTop":"marginTop_uDHS06qF"};